<div class="container-fluid p-0">

    <div class="d-border-bottom">
        <div class="mx-3 my-2 d-flex justify-content-end" >
            <app-language-dropdown [module]="module"></app-language-dropdown>
        </div>
    </div>
    
    <div class="d-border-bottom">
        <div class="p-3" style="position: relative;">
            <label class="form-label" class="d-header-label m-0">
                <!-- ENTER YOUR INCOME -->
                {{'IncomeHead' | propValue | uppercase}}
            </label>
        </div>
    </div>

    <div class="p-3">
        <form>
            <div class="mt-3">
                {{'IncomeParaText1' | propValue }} {{sundayMonth  | propValue}} {{sundayDay}} {{sundayYear}}
                {{'IncomeParaText2' | propValue }} {{saturdayMonth  | propValue}} {{saturdayDay}} {{saturdayYear}}.
                {{'IncomeParaText3' | propValue }}
            </div>

            <div class="my-4 d-flex justify-content-between">
                <button type="button" [class]="btnDesable?'btn btn-continue btn-continue-desable':'btn btn-continue'" (click)="onIncomeSubmit()">
                    {{'btnContinue' | propValue | uppercase}}
                </button>
                <button type="button" [class]="btnDesable?'btn btn-back btn-back-desable':'btn btn-back'" (click)="gotoStart()">
                    {{'btnBack' | propValue | uppercase}}
                </button>
                <button type="button" [class]="btnDesable?'btn btn-cancel btn-cancel-desable':'btn btn-cancel'" (click)="endCall()">
                    {{'btnCancel' | propValue | uppercase}}
                </button>
            </div>

        </form>
    </div>
</div>